'use client';
import { jsx } from 'react/jsx-runtime';
import { PopoverTriggerContext } from '../popover/popover-trigger-context.js';

/**
 * DropdownTriggerContext enables use of the `.Trigger` for the Dropdown component.
 *
 * @example
 * <DropdownTriggerContext>
 *  <DropdownTrigger>Dropdown</DropdownTrigger>
 *  <Dropdown>
 *   <DropdownHeading>Heading</DropdownHeading>
 *    <DropdownList>
 *      <DropdownItem>
 *        <DropdownButton>Button</DropdownButton>
 *      </DropdownItem>
 *    </DropdownList>
 *  </Dropdown>
 * </DropdownTriggerContext>
 */
const DropdownTriggerContext = ({ children, }) => {
    return jsx(PopoverTriggerContext, { children: children });
};
DropdownTriggerContext.displayName = 'DropdownTriggerContext';

export { DropdownTriggerContext };
